<div [formGroup]='form'>
  <div class='adm4-form-group project-repository'>
    <label id='git-repo-label' class='input-label'>
      <span>{{gitRepoLabel}}</span>
      @if (gitRepoIconTooltip) {
        <span class='info-icon-container'>
          <i class="fa fa-info-circle help-icon" aria-hidden="true" [title]='gitRepoIconTooltip'></i>
        </span>
      }
    </label>
    <div class='scan-input'>
      <input class='admn4-text-input form-control'
        [formControlName]="REPOSITORY_FORM_CONTROL_NAME"
        [name]="REPOSITORY_FORM_CONTROL_NAME"
        [class.errored]='repoHasError$ | async'
        (input)='onRepoNameChange()'
        (change)='scan()'
        (ngModelChange)='onRepositoryUrlChange($event)'
        [adm4ControlDisable]='shouldDisableRepoInput(shouldDisableRepoInput$ | async)'
        placeholder=' '/>
      <button type = 'button'
        [disabled]='shouldDisableRepoScanButton()'
        (click)='scan()'>
        <i class="fa fa-repeat input-icon" aria-hidden="true"></i>
      </button>
    </div>
    <div class='validation-message-container'>
      @if (repoHasError$ | async) {
        <adm4-validation-message [isError]='true'
        [message]='repoErrorMessage$ | async'></adm4-validation-message>
      }
    </div>
  </div>
  @if(isHttps && !hideCredentials) {
    <div class='adm4-form-group'>
      <label for='git-user' class='input-label'>
        User
      </label>
      <div class='pat-input-container'>
        <input type='text'
          id='git-user'
          class='admn4-text-input form-control'
          (change)='scan()'
          placeholder='Enter user for authentication on HTTPS URLs'
          [formControlName]="USER_FORM_CONTROL_NAME">
      </div>
    </div>
    <div class='adm4-form-group'>
      <label for='git-password' class='input-label'>
        Password
      </label>
      <div class='pat-input-container'>
        <input type='password'
          id='git-password'
          class='admn4-text-input form-control'
          (change)='scan()'
          placeholder='Enter password for authentication on HTTPS URLs'
          [formControlName]="PASS_FORM_CONTROL_NAME">
      </div>
    </div>
  }
  <div class='adm4-form-group'>
    <label for='import-project-branches' class='input-label'>Branch*</label>
    <mat-form-field class='full-width'>
      <mat-select id='import-project-branches'
        [formControlName]="BRANCH_FORM_CONTROL_NAME"
        [disableOptionCentering]='true'
        [adm4ControlDisable]="shouldDisableBranch(branchDisabled$ | async)">
        @for (branch of branches$ | async; track branch) {
          <mat-option
            [value]='branch'>
            {{branch.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class='validation-message-container'></div>
  </div>
  @if (pathVisible) {
    <div class='adm4-form-group'>
      <label for='import-project-path' class='input-label'>
        Directory@if (pathRequired) {
        *
      }
    </label>
    <input type='text'
      id='import-project-path'
      class='admn4-text-input form-control'
      [class.errored]='form.controls[PATH_FORM_CONTROL_NAME].invalid'
      [placeholder]='pathPlaceholder'
      [formControlName]='PATH_FORM_CONTROL_NAME'
      [adm4ControlDisable]="isDisabled">
    <div class='validation-message-container'>
      @if (shouldShowPathErrorMessage("required")) {
        <adm4-validation-message
          [isError]='true'
          [message]='ERROR_PATH__REQUIRED'
        ></adm4-validation-message>
      }
      @if (shouldShowPathErrorMessage("pattern")) {
        <adm4-validation-message
          [isError]='true'
        [message]='ERROR_INVALID_PATH'></adm4-validation-message>
      }
    </div>
  </div>
}
</div>
